(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'Mfa'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate, Mfa) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.mfaStatus = {enabled: false, available: false};
        vm.mfaLoading = true;
        vm.mfaBusy = false;
        vm.mfaProof = {};
        vm.startMfaSetup = startMfaSetup;
        vm.activateMfa = activateMfa;
        vm.disableMfa = disableMfa;
        vm.cancelMfaSetup = cancelMfaSetup;

        Mfa.status().then(function(status) { vm.mfaStatus = status; })
            .catch(mfaError).finally(function() { vm.mfaLoading = false; });

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function startMfaSetup() {
            if (vm.mfaBusy) { return; }
            vm.mfaBusy = true;
            vm.mfaError = null;
            vm.mfaSuccess = null;
            Mfa.setup(vm.mfaProof).then(function(setup) {
                vm.mfaSetup = setup;
                vm.mfaProof.code = null;
            }).catch(mfaError).finally(function() { vm.mfaBusy = false; });
        }

        function activateMfa() { changeMfa(Mfa.activate, 'mfa.activated'); }
        function disableMfa() { changeMfa(Mfa.disable, 'mfa.disabled'); }

        function changeMfa(operation, message) {
            if (vm.mfaBusy) { return; }
            vm.mfaBusy = true;
            vm.mfaError = null;
            operation(vm.mfaProof).then(function(status) {
                vm.mfaStatus = status;
                vm.mfaSuccess = message;
                cancelMfaSetup();
            }).catch(mfaError).finally(function() { vm.mfaBusy = false; });
        }

        function cancelMfaSetup() {
            vm.mfaSetup = null;
            vm.mfaProof = {};
        }

        function mfaError(error) {
            var key = error.data && error.data.message;
            vm.mfaError = key && key.indexOf('mfa.') === 0 ? key : 'mfa.failed';
            vm.mfaProof.code = null;
        }

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
